/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_Expanding_BrokersInputs */

const cs_import_progress_phase_expanding_brokers = /** @type {(inputs: Import_Progress_Phase_Expanding_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načítání makléřů`)
};

const en_import_progress_phase_expanding_brokers = /** @type {(inputs: Import_Progress_Phase_Expanding_BrokersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading brokers`)
};

/**
* | output |
* | --- |
* | "Loading brokers" |
*
* @param {Import_Progress_Phase_Expanding_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_expanding_brokers = /** @type {((inputs?: Import_Progress_Phase_Expanding_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_Expanding_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_expanding_brokers(inputs)
	return cs_import_progress_phase_expanding_brokers(inputs)
});